import React from 'react';
import { styled } from '@mui/material';
import colors from 'theme/emotion/colors';

interface ProgressBarProps {
  progress: number; // 0-1 representing completion progress
  width?: number | string;
  height?: number | string;
  backgroundColor?: string;
  progressColor?: string;
}

const ProgressContainer = styled('div')<{
  width: number | string;
  height: number | string;
  backgroundColor: string;
}>(({ width, height, backgroundColor }) => ({
  width,
  height,
  backgroundColor,
  borderRadius: '0.25rem',
  overflow: 'hidden',
  position: 'relative',
}));

const ProgressFill = styled('div')<{
  progress: number;
  progressColor: string;
}>(({ progress, progressColor }) => ({
  width: `${Math.max(0, Math.min(100, progress * 100))}%`,
  height: '100%',
  backgroundColor: progressColor,
  borderRadius: 'inherit',
  transition: 'width 0.3s ease-in-out',
}));

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  width = 255,
  height = 4,
  backgroundColor = colors.neutral.grey,
  progressColor = colors.primary.light,
}) => {
  return (
    <ProgressContainer
      width={width}
      height={height}
      backgroundColor={backgroundColor}
    >
      <ProgressFill progress={progress} progressColor={progressColor} />
    </ProgressContainer>
  );
};

export default ProgressBar; 